
const authStore = {
    isLoggedIn: false,
    userDetails: {},
    token: {},
    menuItems: {},
    orgId: '',
    sellerCreation: false,
    accountType: 'user',
    buyNow: [],
    accountDetails: {},
    educationList: [],
    fullEducations: [],
    zodiacSigns: [],
    flaws: [],
    status: [],
    occupation: [],
    allStars: [],
    fullOccupations: [],
    tEducationList: [],
    tFlaws: [],
    tStatus: [],
    tOccupation: [],
    dhisa: [],
    tDhisa:[]
}

export default authStore
